module.exports = __webpack_public_path__ + "static/media/projectview.bea836cf.png";